import { apiClient } from './apiClient';

export type CloneRootKind = 'inbound' | 'outbound' | 'workflow';

export interface CloneSource {
  rootKind: CloneRootKind;
  rootId: string;
  name: string;
  requiresOwner?: boolean;
  isSubWorkflow?: boolean;
  inboundIntegrationId?: string | null;
}

export interface ClonePreflightRequest {
  rootKind: CloneRootKind;
  rootId: string;
  rootName: string;
  dependencyNames: Record<string, string>;
  destinationOwnerWorkflowId?: string;
  destinationInboundAssociation?: { inboundIntegrationId: string | null };
}

export interface CloneNode {
  sourceId: string;
  kind: CloneRootKind | 'subWorkflow';
  name: string;
}

export interface ClonePreflight {
  sourceId: string;
  rootKind: CloneRootKind;
  rootId: string;
  rootName: string;
  preflightToken: string;
  nodes: CloneNode[];
  externalReferences: string[];
  warnings: string[];
  errors: string[];
}

export interface CloneResult {
  rootId: string;
  rootKind: CloneRootKind;
  rootName: string;
  nodes: (CloneNode & { id: string })[];
  requestId: string;
  destinationOwnerWorkflowId?: string;
}

export const resourceClonesApi = {
  preflight: (request: ClonePreflightRequest) =>
    apiClient.post<ClonePreflight>('/api/resource-clones/preflight', request),
  confirm: (request: ClonePreflightRequest & { preflightToken: string; requestId: string }) =>
    apiClient.post<CloneResult>('/api/resource-clones', request),
};
